import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Feriados',
    path: '/calendario/feriados',
    name: 'calferiados',
    component: () => import('@/views/calendario/feriado/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FERIADOSNOVO_MENU_200300199],
    },
  },
];
